// AUTO-GENERATED by tools/generate-parallel.mjs --world 8. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 8
// W8 (Halcyon) — fourth paid-tier world. Depth d=8 floor, d=9 climax.
// // Mix of r=3 and r=4 geometry. 5-6 colors. Enabled by v0.4.4 heuristic.
import type { LevelDef } from '@tessera/engine';

export const WORLD_8_GENERATED: LevelDef[] = [
  // d*=8  branching=16.98  D=0.031  tiles=12
  {
    id: 'w8-l01',
    world: 8,
    index: 1,
    radius: 4,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -4, r: 4 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -4 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: -2 }, color: 0 },
    { coord: { q: 4, r: -3 }, color: 0 },
    { coord: { q: -1, r: 4 }, color: 1 },
    { coord: { q: -2, r: 4 }, color: 1 },
    { coord: { q: 0, r: -4 }, color: 2 },
    { coord: { q: -4, r: 0 }, color: 2 },
    { coord: { q: 1, r: 3 }, color: 3 },
    { coord: { q: 3, r: 1 }, color: 3 },
    ],
  },
  // d*=8  branching=18.83  D=0.038  tiles=13
  {
    id: 'w8-l02',
    world: 8,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 3 },
    { coord: { q: 1, r: 2 }, color: 3 },
    ],
  },
  // d*=8  branching=27.27  D=0.067  tiles=14
  {
    id: 'w8-l03',
    world: 8,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 3 },
    { coord: { q: 2, r: -3 }, color: 3 },
    ],
  },
  // d*=8  branching=21.02  D=0.097  tiles=12
  {
    id: 'w8-l04',
    world: 8,
    index: 4,
    radius: 4,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -4, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: -2 }, color: 0 },
    { coord: { q: 4, r: -1 }, color: 0 },
    { coord: { q: -4, r: 4 }, color: 1 },
    { coord: { q: -4, r: 1 }, color: 1 },
    { coord: { q: -4, r: 0 }, color: 2 },
    { coord: { q: 0, r: -4 }, color: 2 },
    { coord: { q: 3, r: 1 }, color: 3 },
    { coord: { q: 2, r: 2 }, color: 3 },
    ],
  },
  // d*=8  branching=23.79  D=0.158  tiles=12
  {
    id: 'w8-l05',
    world: 8,
    index: 5,
    radius: 4,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -2, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -4, r: 4 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: 0 }, color: 0 },
    { coord: { q: 0, r: 4 }, color: 0 },
    { coord: { q: -4, r: 0 }, color: 1 },
    { coord: { q: -3, r: -1 }, color: 1 },
    { coord: { q: -4, r: 1 }, color: 2 },
    { coord: { q: -4, r: 2 }, color: 2 },
    { coord: { q: 3, r: -4 }, color: 3 },
    { coord: { q: 2, r: -4 }, color: 3 },
    ],
  },
  // d*=9  branching=20.05  D=0.459  tiles=13
  {
    id: 'w8-l06',
    world: 8,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 2, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 3 },
    { coord: { q: 2, r: 1 }, color: 3 },
    ],
  },
  // d*=9  branching=21.19  D=0.486  tiles=13
  {
    id: 'w8-l07',
    world: 8,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 3 },
    { coord: { q: -1, r: 2 }, color: 3 },
    ],
  },
  // d*=9  branching=21.83  D=0.518  tiles=13
  {
    id: 'w8-l08',
    world: 8,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: -3, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 3 },
    { coord: { q: 0, r: 3 }, color: 3 },
    ],
  },
  // d*=9  branching=23.49  D=0.521  tiles=13
  {
    id: 'w8-l09',
    world: 8,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 3 },
    { coord: { q: -1, r: 3 }, color: 3 },
    ],
  },
  // d*=9  branching=24.70  D=0.527  tiles=13
  {
    id: 'w8-l10',
    world: 8,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 0, r: -3 }, color: 3 },
    ],
  },
];
